import { render, staticRenderFns } from "./PracticeForm.vue?vue&type=template&id=360ee4da&"
import script from "./PracticeForm.vue?vue&type=script&lang=ts&"
export * from "./PracticeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports